import type { ProfileRowId } from "../../../lib/readiness/factor-routing";

export function bankComingSoonForRow(
  rowId: ProfileRowId,
  bankIncomeEnabled: boolean,
): boolean {
  return rowId === "income" && !bankIncomeEnabled;
}

// BANK_VERIFIABLE_ROWS / bankVerifiableRow lived here until task 1678.
// Which fields can be bank- or document-verified is now the server's
// answer (GET /api/verification/field-capabilities, asserted once in the
// backend's TestFieldCapabilities) and reaches components through
// useVerificationFieldCapabilities. Do not reintroduce a local set: the
// document half of this decision was never expressed here at all, which is
// exactly how "Upload document" ended up on rows no document can evidence.
